import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.orders;

export const ordersSelector = createSelector(getState, (state) => state.orders);
export const ordersMetaSelector = createSelector(getState, (state) => state.ordersMeta);
export const isLoadingOrdersSelector = createSelector(getState, (state) => state.isLoadingOrders);

export const calculatedExchangeSelector = createSelector(
  getState,
  (state) => state.calculatedExchange,
);

export const selectedOrderSelector = createSelector(getState, (state) => state.selectedOrder);
export const isLoadingOrderSelector = createSelector(getState, (state) => state.isLoadingOrder);

export const orderErrorsSelector = createSelector(getState, (state) => state.errors);
